import React from 'react';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
const NavigationDots = ({ active }) => (
  <motion.div
    className="app__navigation"
    whileHover={{ scale: 1.1 }}
    transition={{ duration: 0.3, type: 'tween' }}
  >
    {[
      'home',
      'about',
      'work',
      'skills',
      'testimonial',
      'contact',
      'learnmore',
      'games',
    ].map((item, index) => (
      <a
        href={`#${item}`}
        key={item + index}
        className="app__navigation-dot"
        style={active === item ? { backgroundColor: '#313BAC' } : {}}
      />
    ))}
  </motion.div>
);

NavigationDots.propTypes = {
  active: PropTypes.string.isRequired,
};

export default NavigationDots;
